import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewChild, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { paths } from '@platform/paths';
import { IconComponent } from '@shared-lib/components/icon/icon.component';
import {
  ScreenSizeBreakpointNames,
  ScreenSizeBreakpointObserverService,
} from '@shared-lib/services/screen-size-breakpoint-observer.service';
import { slideFromTop } from '@shared/animations/slideFromTop';
import { NavigationHeaderProfileSectionComponent } from '@shared/components/navigation-header-profile-section/navigation-header-profile-section.component';
import { NavigationHeaderRadiusContainerComponent } from '@shared/components/navigation-header-radius-container/navigation-header-radius-container.component';
import { HasCompanyClientUiSettingsEnabledDirective } from '@shared/directives/has-company-client-ui-settings-enabled.directive';
import { CompanyClientUISettingsKey } from '@shared/services/company-client-ui-settings.service';
import { selectCompanyLogo, selectCompanyShowAdvisorPage } from '@shared/store/company/company.selectors';
import { ButtonDirective } from 'primeng/button';
import { Observable } from 'rxjs';

@Component({
  selector: 'cp-navigation-header',
  imports: [
    CommonModule,
    IconComponent,
    NavigationHeaderRadiusContainerComponent,
    NgOptimizedImage,
    RouterLink,
    ButtonDirective,
    HasCompanyClientUiSettingsEnabledDirective,
  ],
  templateUrl: './navigation-header.component.html',
  styleUrls: ['./navigation-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [slideFromTop],
})
export class NavigationHeaderComponent {
  @Input({ required: true }) set isMobileHeaderVisible(isMobileHeaderVisible: boolean) {
    this._isMobileHeaderVisible = isMobileHeaderVisible;
    if (!isMobileHeaderVisible) {
      this.imageLoaded = false;
    }
  }

  protected readonly screenSizeBreakpointObserverService = inject(ScreenSizeBreakpointObserverService);
  protected readonly store = inject(Store);
  protected readonly router = inject(Router);
  protected readonly changeDetectorRef = inject(ChangeDetectorRef);

  protected readonly companyLogo$: Observable<string> = this.store.select(selectCompanyLogo);
  protected readonly size$ = this.screenSizeBreakpointObserverService.screenSizeBreakpointName$;
  protected readonly companyShowDashboardAdvisorCard$ = this.store.select(selectCompanyShowAdvisorPage);

  protected readonly parent = parent;
  protected readonly paths = paths;
  protected readonly ScreenSizeBreakpointNames = ScreenSizeBreakpointNames;
  protected readonly showProfilePageKey: CompanyClientUISettingsKey = 'showProfilePage';

  protected _isMobileHeaderVisible = false;
  protected imageLoaded = false;

  @ViewChild('profileSection') profileSection: NavigationHeaderProfileSectionComponent;

  showProfileSection(): void {
    this.profileSection.show();
  }
}
